import z from 'zod'
import {
  firestoreWriteTimestamp,
  nullSafeOptionalBoolean,
  nullSafeOptionalFirestoreTimestamp,
  nullSafeOptionalNumber,
  nullSafeOptionalString,
  nullSafeOptionalStringArray,
  nullSafeStringArray,
} from '../shared/schema'
import { RoomStateDemoType, RoomStateVideoMethod } from './types'

export const schema = z.object({
  absentUserIds: nullSafeOptionalStringArray([]),
  groupLeaderUserIds: nullSafeStringArray([]),
  hiddenUserIds: nullSafeStringArray([]),
  userIds: nullSafeStringArray([]),
  slideDeckId: z.string(),
  activeExhibitId: nullSafeOptionalString(),
  activeSlide: nullSafeOptionalNumber().nullable(),
  activeSlideChangedAt: nullSafeOptionalFirestoreTimestamp().nullable(),
  assignmentId: nullSafeOptionalString(),
  pumpSlide: nullSafeOptionalNumber(),
  roomStateName: nullSafeOptionalString(),
  isDemo: nullSafeOptionalBoolean(),
  demoType: z.nativeEnum(RoomStateDemoType).optional().nullable(),
  scheduledAt: nullSafeOptionalFirestoreTimestamp().nullable(),
  roomStartedAt: nullSafeOptionalFirestoreTimestamp(),
  tokenRegenerationRequestedAt: nullSafeOptionalFirestoreTimestamp(),
  sectionId: nullSafeOptionalString(),
  videoMethod: z.nativeEnum(RoomStateVideoMethod).optional().nullable(),
  updatedAt: nullSafeOptionalFirestoreTimestamp(),
  answerObjectPositions: z
    .record(
      z.string(), // questionId
      z.record(
        z.string(), // answerObjectId
        z.object({
          container: z.string(),
          x: z.number(),
          y: z.number(),
          text: nullSafeOptionalString(),
        })
      )
    )
    .optional(),
  deletable: nullSafeOptionalBoolean(),
  promptVersionOverride: z
    .record(
      z.string(), // promptType
      nullSafeOptionalString() // promptVersionId
    )
    .optional()
    .nullable(),
  assignmentRoles: z
    .record(
      z.string(), // userId
      z.string() // roleId
    )
    .optional()
    .nullable(),
  slideMetadata: z
    .record(
      z.string(), // slideId
      z.record(
        z.string(), // key (e.g., sharedDocumentUrl)
        z.string() // value
      )
    )
    .optional()
    .nullable(),
})

export const empty = Object.freeze(
  schema.parse({
    absentUserIds: [],
    groupLeaderUserIds: [],
    hiddenUserIds: [],
    slideDeckId: '',
    userIds: [],
  })
)

export const writeSchema = schema.extend({
  activeSlide: z.number().nullable(),
  activeExhibitId: nullSafeOptionalString().nullable(),
  activeSlideChangedAt: firestoreWriteTimestamp.nullable(),
  roomStartedAt: firestoreWriteTimestamp,
  scheduledAt: firestoreWriteTimestamp,
  updatedAt: firestoreWriteTimestamp,
})

type FirestoreRoomStateInferred = z.infer<typeof schema>
export type FirestoreRoomState = FirestoreRoomStateInferred
export type FirestoreRoomStateWrite = z.infer<typeof writeSchema>
